// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OverviewSection_root__c0Aw7 {
  display: block;
}

.OverviewSection_root__c0Aw7 hr {
  background-color: var(--color-theme-cloud);
}

.OverviewSection_finding_section__sgtco {
  display: inline-block;
  min-width: 320px;
  max-width: 320px;
  padding-right: 15px;
}

.OverviewSection_overview_section__FZxyb {
  display: inline-block;
  min-width: 500px;
  padding-right: 15px;
}

.OverviewSection_activation_section__1Xkzm {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 15px 20px;
  background-color: var(--color-theme-white);
  border: 1px solid var(--color-theme-cloud);
}

.OverviewSection_host_container__dLRfa {
  flex-grow: 4;
}

.OverviewSection_details_container__H333W {
  display: flex;
}

.OverviewSection_status_container__wT2Yn {
  min-width: 220px;
}

.OverviewSection_status_box__wY5Pa {
  display: flex;
  margin-right: 10px;
  display: flex;
  align-items: center;
}

.OverviewSection_status_name__JYnvo {
  font-size: 20px;
}

.OverviewSection_status_icon__0QAeu {
  margin-right: 10px;
  font-size: 28px;
}

.OverviewSection_status_date__Ca4VP {
  font-size: 14px;
  padding-top: 5px;
}

.OverviewSection_btn_container__OcsYK {
  margin-top: 5px;
}

.OverviewSection_btn_activate__WVO0A {
  width: 150px;
  font-weight: 600 !important;
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  height: 40px;
}

.OverviewSection_btn_view_case__lnfLG {
  margin-left: 5px !important;
  font-size: 14px !important;
  padding: 0px 6px !important;
  color: var(--color-font-10) !important;
  border: 1px solid var(--color-theme-gray) !important;
  background-color: var(--color-theme-gray) !important;
}
.OverviewSection_view_case_icon__RCZxm {
  margin-left: 5px;
  transform: scale(0.8);
}
.OverviewSection_btn_activate__WVO0A:disabled {
  width: 150px;
  font-weight: 600 !important;
  color: var(--color-font-10) !important;
  border: 1px solid var(--color-theme-gray) !important;
  background-color: var(--color-theme-gray) !important;
  height: 40px;
}

.OverviewSection_btn_cancel__1WKgg {
  width: 150px;
  font-weight: 600 !important;
  color: var(--color-font-red) !important;
  border: 1px solid var(--color-theme-red) !important;
  height: 40px;
}

.OverviewSection_btn_cancel__1WKgg:disabled {
  color: var(--color-theme-deactivated) !important;
  border: 1px solid var(--color-theme-deactivated) !important;
  background-color: var(--color-theme-gray) !important;
}

.OverviewSection_btn_reset__FaSvi {
  width: 150px;
  font-weight: 600 !important;
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  background-color: var(--color-theme-white) !important;
  height: 40px;
}

.OverviewSection_btn_payment__TM26j {
  width: 150px;
  font-weight: 600 !important;
  color: var(--color-font-10) !important;
  height: 40px;
}

.OverviewSection_host__BiUh5 {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.5px;
  overflow: hidden;
  white-space: nowrap;
  max-width: 350px;
  text-overflow: ellipsis;
}

.OverviewSection_source_id__ra0CR {
  font-size: 14px;
  padding-top: 8px;
}

hr {
  height: 1px;
  border: none;
  background-color: var(--color-bg-hr);
  margin: 0;
}

.OverviewSection_contact_container__QCT6G {
  padding: 5px 20px;
  cursor: pointer;
  position: relative;
}

.OverviewSection_email_flow_container__l7MnT {
  padding: 5px 0px 8px 20px;
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.OverviewSection_email_flow_container__l7MnT:hover {
  background-color: var(--color-bg-content-box-hover);
}

.OverviewSection_no_hover__8\\+9ED {
  background-color: unset !important;
  cursor: default;
}

.OverviewSection_disabled__j3iLT {
  pointer-events: none;
  opacity: 0.6;
}

.OverviewSection_contact_container__QCT6G:hover {
  background-color: var(--color-bg-content-box-hover);
}

.OverviewSection_contact_info_box__Ng7fF {
  padding: 15px 0;
}

.OverviewSection_contact_small_title__QMpSe {
  font-size: 14px;
}

.OverviewSection_contact_big_title__mGUBP {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.OverviewSection_claim_container__-hMBY {
  padding: 5px 20px;
  cursor: pointer;
  position: relative;
}
.OverviewSection_claim_container__-hMBY:hover {
  background-color: var(--color-bg-content-box-hover);
}

.OverviewSection_claim_content__rZkzA {
  display: flex;
}

.OverviewSection_claim_info_box__0aijB {
  padding: 10px 0;
  min-width: 155px;
}

.OverviewSection_claim_small_title__O8X0\\+ {
  font-size: 14px;
}

.OverviewSection_claim_small_title_component__PpSE5 {
  font-size: 14px;
  min-width: 210px;
}

.OverviewSection_claim_big_title__8pSL6 {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.OverviewSection_deadline_container__q7OZt {
  position: relative;
  padding-left: 20px;
}

.OverviewSection_deadline_title_container__6k9Vy {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.OverviewSection_deadline_content__rzwN1 {
  position: relative;
  display: flex;
  align-items: center;
}

.OverviewSection_deadline_info_box__d7jid {
  padding: 10px 0;
  min-width: 155px;
}

.OverviewSection_deadline_small_title__aNjh- {
  font-size: 14px;
}

.OverviewSection_deadline_small_title_component__ujfME {
  font-size: 14px;
  min-width: 210px;
}

.OverviewSection_deadline_big_title__YH3f\\+ {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.OverviewSection_valid_box__3onGg {
  margin-top: 5px;
  float: right;
}

.OverviewSection_not_valid_box__0Wzbm {
  margin-top: 5px;
  float: right;
}

.OverviewSection_valid_box__3onGg svg {
  color: var(--color-theme-green);
}

.OverviewSection_not_valid_box__0Wzbm svg {
  color: var(--color-theme-yellow);
}

.OverviewSection_currency__797DK {
  font-size: 16px;
}

.OverviewSection_cancel_icon__5Q4UG {
  display: inline-block;
  margin-right: 10px;
  font-size: 34px;
}
.OverviewSection_case_templage_container__6wrIz {
  text-align: right;
}
.OverviewSection_cancel_icon__5Q4UG:hover {
  color: var(--color-theme-red);
}

.OverviewSection_activate_btns_container__L-flX {
  display: flex;
  cursor: pointer;
}

.OverviewSection_image_list__tKoMP {
  background-color: var(--color-bg-content-evidence);
  display: flex;
  flex-flow: row;
  overflow-x: scroll;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border: 2px solid var(--color-theme-cloud);
  position: relative;
  min-width: 310px;
}

.OverviewSection_image_item__UGudj {
  height: 395px;
  width: 100%;
  border-radius: 2px;
  object-fit: cover;
}

.OverviewSection_evidence_container__cZGF7 {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  background-color: var(--color-bg-content-evidence);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  border: 1px solid var(--color-theme-cloud);
  border-top: none;
}

.OverviewSection_evidence_action__lRVJH {
  display: flex;
  padding: 16px;
  height: 0px;
}

.OverviewSection_evidence_text__MThiC {
  padding: 20px;
  font-size: 14px;
  font-weight: 600;
}

.OverviewSection_finding_count__QoxGz {
  line-height: 22px;
  margin-right: 10px;
  font-weight: 500;
  font-size: 14px;
}

.OverviewSection_evidence_action__lRVJH svg {
  width: 25px;
  height: 25px;
}

.OverviewSection_image_icons_container__L3iPb {
  position: absolute;
  display: flex;
  bottom: 5px;
  padding: 5px;
  right: 0px;
  width: 100%;
  overflow: scroll;
  justify-content: flex-end;
}

.OverviewSection_image_icon__X1STR {
  cursor: pointer;
  margin-right: 5px;
  height: 40px;
  width: 50px;
  object-fit: cover;
  border-radius: 5px;
  border: 1px solid var(--color-theme-10);
  transition: all 0.1s ease;
  -webkit-transition: all 0.1s ease;
}

.OverviewSection_image_icon__X1STR:hover {
  border: 1px solid var(--color-theme-3);
}

.OverviewSection_image_icon_selected__iroxz {
  cursor: pointer;
  margin-right: 5px;
  height: 40px;
  width: 50px;
  object-fit: cover;
  border-radius: 5px;
  border: 1px solid var(--color-theme-3);
}

.OverviewSection_no_finding_container__8pE2t {
  height: 395px;
  width: 100%;
  border-radius: 2px;
  object-fit: cover;
  min-width: 330px;
}

.OverviewSection_add_finding_container__O7-u\\+ {
  text-align: right;
  width: 306px;
  background-color: var(--color-bg-caselist);
  margin-right: 10px;
  margin-top: 10px;
}

.OverviewSection_btn_add_finding__JBzBA {
  flex: 2 1;
  width: 190px !important;
  font-weight: 600 !important;
  color: var(--color-font-10) !important;
  height: 40px;
  line-height: 0px !important;
  margin-left: 40px;
}

.OverviewSection_btn_add_finding_disabled__JnMpP {
  flex: 2 1;
  width: 190px !important;
  font-weight: 600 !important;
  color: var(--color-theme-lightgray) !important;
  height: 40px;
  line-height: 0px !important;
  margin-left: 40px;
}

.OverviewSection_plus_sign__tYT14 {
  margin-right: 10px;
  font-size: 20px;
}

.OverviewSection_btn_add_finding__JBzBA:hover {
  color: var(--color-theme-blue) !important;
  background-color: var(--color-theme-lightblue) !important;
}

.OverviewSection_no_finding_container_with_image__Hg1bS {
  margin-top: 10px;
  margin-right: 10px;
  position: absolute;
  right: 0;
  background-color: var(--color-bg-caselist);
}

.OverviewSection_btn_add_finding_with_image__nIIbb {
  width: 190px !important;
  font-weight: 600 !important;
  color: var(--color-font-10) !important;
  height: 40px;
  line-height: 0px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.OverviewSection_template_container__sY1hn {
  color: var(--color-font-10);
  text-decoration: none;
  display: flex;
  padding-top: 4px;
  cursor: pointer;
  align-content: space-between;
  flex-direction: row;
  justify-content: left;
  align-items: flex-start;
}

.OverviewSection_case_templage_container__6wrIz {
  width: 100%;
}

.OverviewSection_case_template_title__pQD88 {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}

.OverviewSection_case_template_title__pQD88 .OverviewSection_MuiAutocomplete-inputRoot__4\\+7nM {
  height: 55px !important;
}

.OverviewSection_template_icon__aiZ89 svg {
  height: 25px;
  padding-top: 0px;
}

.OverviewSection_template_title__VD2an {
  padding-left: 10px;
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: bold;
}

.OverviewSection_warning_icon__WHtes {
  color: var(--color-theme-yellow);
  margin-left: 10px;
  margin-top: 2px;
}

.OverviewSection_eye_icon__pbT6a {
  color: var(--color-theme-white);
  margin-left: 10px;
  margin-top: 9px;
  cursor: pointer;
}

.OverviewSection_btn_send_email__iF7do {
  color: var(--color-font-10) !important;
  border-color: var(--color-font-10) !important;
}

.OverviewSection_btn_add_deadline__qlZ0- {
  color: var(--color-font-10) !important;
  border-color: var(--color-font-10) !important;
  position: relative;
  top: 15px;
  z-index: 99;
}

.OverviewSection_template_dropdown__TWD77 {
  min-width: 250px !important;
}

.OverviewSection_template_dropdown_first__Bs\\+5G {
  min-width: 250px !important;
  border-bottom: 1px solid var(--color-border) !important;
}

.OverviewSection_title__3FotY {
  font-size: 16px;
  padding-top: 10px;
  font-weight: bold;
}

.OverviewSection_tag_chip__qlUQK {
  margin-right: 5px;
  margin-bottom: 5px;
  max-width: 300px;
}

.OverviewSection_tag_section__40tfH {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.OverviewSection_tags_container__RlL8w {
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 85%;
}

.OverviewSection_add_tag_icon__13Fsc {
  color: rgba(0, 0, 0, 0.36);
  margin-top: 11px;
  cursor: pointer;
}

.OverviewSection_add_tag_icon__13Fsc :hover {
  color: rgba(0, 0, 0, 0.46);
}
`, "",{"version":3,"sources":["webpack://./src/@_components/sections/OverviewSection/OverviewSection.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,yCAAyC;EACzC,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,sCAAsC;EACtC,oDAAoD;EACpD,oDAAoD;AACtD;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,sCAAsC;EACtC,oDAAoD;EACpD,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,uCAAuC;EACvC,mDAAmD;EACnD,YAAY;AACd;;AAEA;EACE,gDAAgD;EAChD,2DAA2D;EAC3D,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,yCAAyC;EACzC,oDAAoD;EACpD,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mDAAmD;AACrD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kDAAkD;EAClD,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,kDAAkD;EAClD,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,2BAA2B;EAC3B,sCAAsC;EACtC,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,2BAA2B;EAC3B,8CAA8C;EAC9C,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,yDAAyD;AAC3D;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,sCAAsC;EACtC,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;EAC7C,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,uDAAuD;AACzD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".root {\n  display: block;\n}\n\n.root hr {\n  background-color: var(--color-theme-cloud);\n}\n\n.finding_section {\n  display: inline-block;\n  min-width: 320px;\n  max-width: 320px;\n  padding-right: 15px;\n}\n\n.overview_section {\n  display: inline-block;\n  min-width: 500px;\n  padding-right: 15px;\n}\n\n.activation_section {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  padding: 15px 20px;\n  background-color: var(--color-theme-white);\n  border: 1px solid var(--color-theme-cloud);\n}\n\n.host_container {\n  flex-grow: 4;\n}\n\n.details_container {\n  display: flex;\n}\n\n.status_container {\n  min-width: 220px;\n}\n\n.status_box {\n  display: flex;\n  margin-right: 10px;\n  display: flex;\n  align-items: center;\n}\n\n.status_name {\n  font-size: 20px;\n}\n\n.status_icon {\n  margin-right: 10px;\n  font-size: 28px;\n}\n\n.status_date {\n  font-size: 14px;\n  padding-top: 5px;\n}\n\n.btn_container {\n  margin-top: 5px;\n}\n\n.btn_activate {\n  width: 150px;\n  font-weight: 600 !important;\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  height: 40px;\n}\n\n.btn_view_case {\n  margin-left: 5px !important;\n  font-size: 14px !important;\n  padding: 0px 6px !important;\n  color: var(--color-font-10) !important;\n  border: 1px solid var(--color-theme-gray) !important;\n  background-color: var(--color-theme-gray) !important;\n}\n.view_case_icon {\n  margin-left: 5px;\n  transform: scale(0.8);\n}\n.btn_activate:disabled {\n  width: 150px;\n  font-weight: 600 !important;\n  color: var(--color-font-10) !important;\n  border: 1px solid var(--color-theme-gray) !important;\n  background-color: var(--color-theme-gray) !important;\n  height: 40px;\n}\n\n.btn_cancel {\n  width: 150px;\n  font-weight: 600 !important;\n  color: var(--color-font-red) !important;\n  border: 1px solid var(--color-theme-red) !important;\n  height: 40px;\n}\n\n.btn_cancel:disabled {\n  color: var(--color-theme-deactivated) !important;\n  border: 1px solid var(--color-theme-deactivated) !important;\n  background-color: var(--color-theme-gray) !important;\n}\n\n.btn_reset {\n  width: 150px;\n  font-weight: 600 !important;\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  background-color: var(--color-theme-white) !important;\n  height: 40px;\n}\n\n.btn_payment {\n  width: 150px;\n  font-weight: 600 !important;\n  color: var(--color-font-10) !important;\n  height: 40px;\n}\n\n.host {\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  overflow: hidden;\n  white-space: nowrap;\n  max-width: 350px;\n  text-overflow: ellipsis;\n}\n\n.source_id {\n  font-size: 14px;\n  padding-top: 8px;\n}\n\nhr {\n  height: 1px;\n  border: none;\n  background-color: var(--color-bg-hr);\n  margin: 0;\n}\n\n.contact_container {\n  padding: 5px 20px;\n  cursor: pointer;\n  position: relative;\n}\n\n.email_flow_container {\n  padding: 5px 0px 8px 20px;\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.email_flow_container:hover {\n  background-color: var(--color-bg-content-box-hover);\n}\n\n.no_hover {\n  background-color: unset !important;\n  cursor: default;\n}\n\n.disabled {\n  pointer-events: none;\n  opacity: 0.6;\n}\n\n.contact_container:hover {\n  background-color: var(--color-bg-content-box-hover);\n}\n\n.contact_info_box {\n  padding: 15px 0;\n}\n\n.contact_small_title {\n  font-size: 14px;\n}\n\n.contact_big_title {\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.claim_container {\n  padding: 5px 20px;\n  cursor: pointer;\n  position: relative;\n}\n.claim_container:hover {\n  background-color: var(--color-bg-content-box-hover);\n}\n\n.claim_content {\n  display: flex;\n}\n\n.claim_info_box {\n  padding: 10px 0;\n  min-width: 155px;\n}\n\n.claim_small_title {\n  font-size: 14px;\n}\n\n.claim_small_title_component {\n  font-size: 14px;\n  min-width: 210px;\n}\n\n.claim_big_title {\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.deadline_container {\n  position: relative;\n  padding-left: 20px;\n}\n\n.deadline_title_container {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.deadline_content {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.deadline_info_box {\n  padding: 10px 0;\n  min-width: 155px;\n}\n\n.deadline_small_title {\n  font-size: 14px;\n}\n\n.deadline_small_title_component {\n  font-size: 14px;\n  min-width: 210px;\n}\n\n.deadline_big_title {\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.valid_box {\n  margin-top: 5px;\n  float: right;\n}\n\n.not_valid_box {\n  margin-top: 5px;\n  float: right;\n}\n\n.valid_box svg {\n  color: var(--color-theme-green);\n}\n\n.not_valid_box svg {\n  color: var(--color-theme-yellow);\n}\n\n.currency {\n  font-size: 16px;\n}\n\n.cancel_icon {\n  display: inline-block;\n  margin-right: 10px;\n  font-size: 34px;\n}\n.case_templage_container {\n  text-align: right;\n}\n.cancel_icon:hover {\n  color: var(--color-theme-red);\n}\n\n.activate_btns_container {\n  display: flex;\n  cursor: pointer;\n}\n\n.image_list {\n  background-color: var(--color-bg-content-evidence);\n  display: flex;\n  flex-flow: row;\n  overflow-x: scroll;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  border: 2px solid var(--color-theme-cloud);\n  position: relative;\n  min-width: 310px;\n}\n\n.image_item {\n  height: 395px;\n  width: 100%;\n  border-radius: 2px;\n  object-fit: cover;\n}\n\n.evidence_container {\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n  background-color: var(--color-bg-content-evidence);\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  border: 1px solid var(--color-theme-cloud);\n  border-top: none;\n}\n\n.evidence_action {\n  display: flex;\n  padding: 16px;\n  height: 0px;\n}\n\n.evidence_text {\n  padding: 20px;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.finding_count {\n  line-height: 22px;\n  margin-right: 10px;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.evidence_action svg {\n  width: 25px;\n  height: 25px;\n}\n\n.image_icons_container {\n  position: absolute;\n  display: flex;\n  bottom: 5px;\n  padding: 5px;\n  right: 0px;\n  width: 100%;\n  overflow: scroll;\n  justify-content: flex-end;\n}\n\n.image_icon {\n  cursor: pointer;\n  margin-right: 5px;\n  height: 40px;\n  width: 50px;\n  object-fit: cover;\n  border-radius: 5px;\n  border: 1px solid var(--color-theme-10);\n  transition: all 0.1s ease;\n  -webkit-transition: all 0.1s ease;\n}\n\n.image_icon:hover {\n  border: 1px solid var(--color-theme-3);\n}\n\n.image_icon_selected {\n  cursor: pointer;\n  margin-right: 5px;\n  height: 40px;\n  width: 50px;\n  object-fit: cover;\n  border-radius: 5px;\n  border: 1px solid var(--color-theme-3);\n}\n\n.no_finding_container {\n  height: 395px;\n  width: 100%;\n  border-radius: 2px;\n  object-fit: cover;\n  min-width: 330px;\n}\n\n.add_finding_container {\n  text-align: right;\n  width: 306px;\n  background-color: var(--color-bg-caselist);\n  margin-right: 10px;\n  margin-top: 10px;\n}\n\n.btn_add_finding {\n  flex: 2;\n  width: 190px !important;\n  font-weight: 600 !important;\n  color: var(--color-font-10) !important;\n  height: 40px;\n  line-height: 0px !important;\n  margin-left: 40px;\n}\n\n.btn_add_finding_disabled {\n  flex: 2;\n  width: 190px !important;\n  font-weight: 600 !important;\n  color: var(--color-theme-lightgray) !important;\n  height: 40px;\n  line-height: 0px !important;\n  margin-left: 40px;\n}\n\n.plus_sign {\n  margin-right: 10px;\n  font-size: 20px;\n}\n\n.btn_add_finding:hover {\n  color: var(--color-theme-blue) !important;\n  background-color: var(--color-theme-lightblue) !important;\n}\n\n.no_finding_container_with_image {\n  margin-top: 10px;\n  margin-right: 10px;\n  position: absolute;\n  right: 0;\n  background-color: var(--color-bg-caselist);\n}\n\n.btn_add_finding_with_image {\n  width: 190px !important;\n  font-weight: 600 !important;\n  color: var(--color-font-10) !important;\n  height: 40px;\n  line-height: 0px !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.template_container {\n  color: var(--color-font-10);\n  text-decoration: none;\n  display: flex;\n  padding-top: 4px;\n  cursor: pointer;\n  align-content: space-between;\n  flex-direction: row;\n  justify-content: left;\n  align-items: flex-start;\n}\n\n.case_templage_container {\n  width: 100%;\n}\n\n.case_template_title {\n  width: 100%;\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  flex-direction: row;\n  align-items: center;\n}\n\n.case_template_title .MuiAutocomplete-inputRoot {\n  height: 55px !important;\n}\n\n.template_icon svg {\n  height: 25px;\n  padding-top: 0px;\n}\n\n.template_title {\n  padding-left: 10px;\n  display: flex;\n  align-items: center;\n  font-size: 22px;\n  font-weight: bold;\n}\n\n.warning_icon {\n  color: var(--color-theme-yellow);\n  margin-left: 10px;\n  margin-top: 2px;\n}\n\n.eye_icon {\n  color: var(--color-theme-white);\n  margin-left: 10px;\n  margin-top: 9px;\n  cursor: pointer;\n}\n\n.btn_send_email {\n  color: var(--color-font-10) !important;\n  border-color: var(--color-font-10) !important;\n}\n\n.btn_add_deadline {\n  color: var(--color-font-10) !important;\n  border-color: var(--color-font-10) !important;\n  position: relative;\n  top: 15px;\n  z-index: 99;\n}\n\n.template_dropdown {\n  min-width: 250px !important;\n}\n\n.template_dropdown_first {\n  min-width: 250px !important;\n  border-bottom: 1px solid var(--color-border) !important;\n}\n\n.title {\n  font-size: 16px;\n  padding-top: 10px;\n  font-weight: bold;\n}\n\n.tag_chip {\n  margin-right: 5px;\n  margin-bottom: 5px;\n  max-width: 300px;\n}\n\n.tag_section {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.tags_container {\n  margin-top: 8px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  width: 85%;\n}\n\n.add_tag_icon {\n  color: rgba(0, 0, 0, 0.36);\n  margin-top: 11px;\n  cursor: pointer;\n}\n\n.add_tag_icon :hover {\n  color: rgba(0, 0, 0, 0.46);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `OverviewSection_root__c0Aw7`,
	"finding_section": `OverviewSection_finding_section__sgtco`,
	"overview_section": `OverviewSection_overview_section__FZxyb`,
	"activation_section": `OverviewSection_activation_section__1Xkzm`,
	"host_container": `OverviewSection_host_container__dLRfa`,
	"details_container": `OverviewSection_details_container__H333W`,
	"status_container": `OverviewSection_status_container__wT2Yn`,
	"status_box": `OverviewSection_status_box__wY5Pa`,
	"status_name": `OverviewSection_status_name__JYnvo`,
	"status_icon": `OverviewSection_status_icon__0QAeu`,
	"status_date": `OverviewSection_status_date__Ca4VP`,
	"btn_container": `OverviewSection_btn_container__OcsYK`,
	"btn_activate": `OverviewSection_btn_activate__WVO0A`,
	"btn_view_case": `OverviewSection_btn_view_case__lnfLG`,
	"view_case_icon": `OverviewSection_view_case_icon__RCZxm`,
	"btn_cancel": `OverviewSection_btn_cancel__1WKgg`,
	"btn_reset": `OverviewSection_btn_reset__FaSvi`,
	"btn_payment": `OverviewSection_btn_payment__TM26j`,
	"host": `OverviewSection_host__BiUh5`,
	"source_id": `OverviewSection_source_id__ra0CR`,
	"contact_container": `OverviewSection_contact_container__QCT6G`,
	"email_flow_container": `OverviewSection_email_flow_container__l7MnT`,
	"no_hover": `OverviewSection_no_hover__8+9ED`,
	"disabled": `OverviewSection_disabled__j3iLT`,
	"contact_info_box": `OverviewSection_contact_info_box__Ng7fF`,
	"contact_small_title": `OverviewSection_contact_small_title__QMpSe`,
	"contact_big_title": `OverviewSection_contact_big_title__mGUBP`,
	"claim_container": `OverviewSection_claim_container__-hMBY`,
	"claim_content": `OverviewSection_claim_content__rZkzA`,
	"claim_info_box": `OverviewSection_claim_info_box__0aijB`,
	"claim_small_title": `OverviewSection_claim_small_title__O8X0+`,
	"claim_small_title_component": `OverviewSection_claim_small_title_component__PpSE5`,
	"claim_big_title": `OverviewSection_claim_big_title__8pSL6`,
	"deadline_container": `OverviewSection_deadline_container__q7OZt`,
	"deadline_title_container": `OverviewSection_deadline_title_container__6k9Vy`,
	"deadline_content": `OverviewSection_deadline_content__rzwN1`,
	"deadline_info_box": `OverviewSection_deadline_info_box__d7jid`,
	"deadline_small_title": `OverviewSection_deadline_small_title__aNjh-`,
	"deadline_small_title_component": `OverviewSection_deadline_small_title_component__ujfME`,
	"deadline_big_title": `OverviewSection_deadline_big_title__YH3f+`,
	"valid_box": `OverviewSection_valid_box__3onGg`,
	"not_valid_box": `OverviewSection_not_valid_box__0Wzbm`,
	"currency": `OverviewSection_currency__797DK`,
	"cancel_icon": `OverviewSection_cancel_icon__5Q4UG`,
	"case_templage_container": `OverviewSection_case_templage_container__6wrIz`,
	"activate_btns_container": `OverviewSection_activate_btns_container__L-flX`,
	"image_list": `OverviewSection_image_list__tKoMP`,
	"image_item": `OverviewSection_image_item__UGudj`,
	"evidence_container": `OverviewSection_evidence_container__cZGF7`,
	"evidence_action": `OverviewSection_evidence_action__lRVJH`,
	"evidence_text": `OverviewSection_evidence_text__MThiC`,
	"finding_count": `OverviewSection_finding_count__QoxGz`,
	"image_icons_container": `OverviewSection_image_icons_container__L3iPb`,
	"image_icon": `OverviewSection_image_icon__X1STR`,
	"image_icon_selected": `OverviewSection_image_icon_selected__iroxz`,
	"no_finding_container": `OverviewSection_no_finding_container__8pE2t`,
	"add_finding_container": `OverviewSection_add_finding_container__O7-u+`,
	"btn_add_finding": `OverviewSection_btn_add_finding__JBzBA`,
	"btn_add_finding_disabled": `OverviewSection_btn_add_finding_disabled__JnMpP`,
	"plus_sign": `OverviewSection_plus_sign__tYT14`,
	"no_finding_container_with_image": `OverviewSection_no_finding_container_with_image__Hg1bS`,
	"btn_add_finding_with_image": `OverviewSection_btn_add_finding_with_image__nIIbb`,
	"template_container": `OverviewSection_template_container__sY1hn`,
	"case_template_title": `OverviewSection_case_template_title__pQD88`,
	"MuiAutocomplete-inputRoot": `OverviewSection_MuiAutocomplete-inputRoot__4+7nM`,
	"template_icon": `OverviewSection_template_icon__aiZ89`,
	"template_title": `OverviewSection_template_title__VD2an`,
	"warning_icon": `OverviewSection_warning_icon__WHtes`,
	"eye_icon": `OverviewSection_eye_icon__pbT6a`,
	"btn_send_email": `OverviewSection_btn_send_email__iF7do`,
	"btn_add_deadline": `OverviewSection_btn_add_deadline__qlZ0-`,
	"template_dropdown": `OverviewSection_template_dropdown__TWD77`,
	"template_dropdown_first": `OverviewSection_template_dropdown_first__Bs+5G`,
	"title": `OverviewSection_title__3FotY`,
	"tag_chip": `OverviewSection_tag_chip__qlUQK`,
	"tag_section": `OverviewSection_tag_section__40tfH`,
	"tags_container": `OverviewSection_tags_container__RlL8w`,
	"add_tag_icon": `OverviewSection_add_tag_icon__13Fsc`
};
export default ___CSS_LOADER_EXPORT___;
